import { Descendant, Element, Text } from "slate";

import ElementType from "../../../type/slate/ElementType";

const serializeNodeToString = (node: Descendant): string => {
  if (Element.isElement(node)) {
    switch (node.type) {
      case ElementType.PARAGRAPH:
        return node.children.map(serializeNodeToString).join("");
      case ElementType.DYNAMIC_VARIABLE:
        return node.value;
      default:
        return "";
    }
  }

  if (Text.isText(node)) {
    return node.text;
  }

  return "";
};

const serializeToString = (nodes: Descendant[]): string => {
  return nodes.map(serializeNodeToString).join("");
};

export default serializeToString;
